<template>
  <div class="app-container statistics-list">
    <div class="statistics-list-filter">
      <el-row>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-date-picker
              class="statistics-list-filter-date"
              v-model="search.searchTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              start-placeholder="培训开始时间"
              end-placeholder="培训结束时间"
              size="small">
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-input class="statistics-list-filter-value" v-model.trim="search.activityName" @keyup.enter.native="searchChange" placeholder="培训课程名称" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-input class="statistics-list-filter-value" v-model.trim="search.projectGroupName" @keyup.enter.native="searchChange" placeholder="项目组名称" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-select class="statistics-list-filter-value" v-model="search.organizedBy" @change="searchChange" filterable clearable size="small" placeholder="培训团队名称">
              <el-option
                v-for="item in organizedByOptions"
                :key="item.value"
                :label="item.label"
                :value="item.label">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-input class="statistics-list-filter-value" v-model.trim="search.lecturer" @keyup.enter.native="searchChange" placeholder="培训老师名称" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            <el-button class="statistics-list-filter-reset" size="small" @click="searchChange">立即筛选</el-button>
            <el-button class="statistics-list-filter-search" size="small" @click="searchReset">清除条件</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <basic-container class="statistics-list-container">
      <avue-crud ref="crud"
                 :option="tableOption"
                 :data="list"
                 :page="page"
                 :table-loading="listLoading"
                 @current-change="handleCurrentChange"
                 @refresh-change="handleRefreshChange"
                 @size-change="handleSizeChange"
                 @sort-change="handleSortChange">

        <template slot="questionnaireParticipantCount"
                  slot-scope="{row}">
          {{`${row.questionnaireParticipantCountDisplay}`}}
        </template>

        <template slot="questionnaireTotalScore"
                  slot-scope="{row}">
          {{`${row.questionnaireTotalScoreDisplay}`}}
        </template>

        <template slot="questionnaireAverageScore"
                  slot-scope="{row}">
          {{`${row.questionnaireAverageScoreDisplay}`}}
        </template>

        <template slot="questionnaireParticipationRate"
                  slot-scope="{row}">
          {{`${row.questionnaireParticipationRateDisplay}`}}
        </template>

        <template slot="participationRate"
                  slot-scope="{row}">
          {{`${row.participationRate}%`}}
        </template>

        <template slot="menuLeft">
          <el-button
            v-if="permissions.analysis_activity_export"
            class="filter-item"
            @click="handleExport()"
            size="small"
            type="primary"
            :loading="exportLoading"
            icon="el-icon-download">{{exportName}}
          </el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
  import { fetchTrainingCourseStatisticsSummary, exportTrainingCourseStatisticsSummary } from '@/api/analysis/activityAnalysis'
  import { exporting } from '@/util/exportUtil'
  import {getSubLobsByDepartment} from '@/api/admin/member'
  import { organizedByOptions } from '@/const/crud/app/activity';
  import {tableOption} from '@/const/crud/analysis/activityAnalysis'
  import {mapGetters} from "vuex";

  export default {
    data() {
      return {
        search: {
          current: 1,
          size: 10,
          searchTime: [],
          sortField: '',
          sortPolicy: '',
          activityName: '',
          projectGroupName: '',
          organizedBy: '',
          lecturer: '',
        },
        exportLoading: false,
        exportName: '导出',
        page: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
        },
        tableOption: tableOption,
        listLoading: false,
        form: {},
        subLobList: [],
        organizedByOptions: organizedByOptions,
      };
    },
    activated () {
      // this.fetchSubLobList()
      this.initPage()
      this.getStatisticsSummaryData()
    },
    async created() {
      // this.fetchSubLobList()
      await this.initPage()
      await this.getStatisticsSummaryData()
    },
    computed: {
      ...mapGetters(['permissions']),
      startTime: function () {
        if (this.search.searchTime && this.search.searchTime.length > 0) {
          return this.search.searchTime[0]
        } else {
          return null
        }
      },
      endTime: function () {
        if (this.search.searchTime && this.search.searchTime.length > 1) {
          return this.search.searchTime[1]
        } else {
          return null
        }
      }
    },
    methods: {
      formatData(records) {
        let _this = this
        if (records && records.length > 0) {
          records.forEach(function(record, index) {
            if (!record.activityName) { record.activityName = '--' }
            if (!record.projectGroupName) { record.projectGroupName = '--' }
            if (!record.projectName) { record.projectName = '--' }
            if (!record.organizedBy) { record.organizedBy = '--' }
            if (!record.lecturer) { record.lecturer = '--' }
            if (!record.startTime) { record.startTime = '--' }
            if (!record.endTime) { record.endTime = '--' }
            if (!record.questionnaireId) {
              record.questionnaireParticipantCount = -1
              record.questionnaireParticipantCountDisplay = "--"
              record.questionnaireTotalScore = -1
              record.questionnaireTotalScoreDisplay = "--"
              record.questionnaireAverageScore = -1
              record.questionnaireAverageScoreDisplay = "--"
              record.questionnaireParticipationRate = -1
              record.questionnaireParticipationRateDisplay = "--"
            } else {
              record.questionnaireParticipantCountDisplay = record.questionnaireParticipantCount
              record.questionnaireTotalScoreDisplay = record.questionnaireTotalScore
              record.questionnaireAverageScoreDisplay = record.questionnaireAverageScore
              record.questionnaireParticipationRateDisplay = `${record.questionnaireParticipationRate}%`
            }
          })
        }
        return records
      },
      fetchSubLobList() {
        let params = {
          department: '',
        }
        getSubLobsByDepartment(params).then(response => {
            if (response.status == 200) {
            this.subLobList = response.data.data
          }
        }).catch(err => {
        })
      },
      getStatisticsSummaryData() {
        let params = {
          current: this.search.current,
          size: this.search.size,
        }
        if (this.search.activityName != '' && this.search.activityName.trim() != '')
          params.activityName = this.search.activityName
        if (this.search.projectGroupName != '' && this.search.projectGroupName.trim() != '')
          params.projectGroupName = this.search.projectGroupName
        if (this.search.organizedBy != '' && this.search.organizedBy.trim() != '')
          params.organizedBy = this.search.organizedBy
        if (this.search.lecturer != '' && this.search.lecturer.trim() != '')
          params.lecturer = this.search.lecturer

        if (this.startTime && this.endTime) {
          params.startTime = this.startTime
          params.endTime = this.endTime
        } else {
          params.startTime = null
          params.endTime = null
        }

        if (this.search.sortField != '' && this.search.sortField.trim() != '')
          params.sortField = this.search.sortField
        else {
          params.sortField = 'id'
        }
        if (this.search.sortPolicy != '' && this.search.sortPolicy.trim() != '')
          params.sortPolicy = this.search.sortPolicy
        else {
          params.sortPolicy = 'desc'
        }
        this.listLoading = true
        fetchTrainingCourseStatisticsSummary(params).then(response => {
          this.list = this.formatData(response.data.data.records)
          this.page.total = response.data.data.total
          this.listLoading = false
        });
      },
      initPage() {
        this.page.currentPage = 1
        this.page.pageSize = this.search.size
        this.search.current = 1
      },
      searchChange() {
        this.initPage()
        this.getStatisticsSummaryData()
      },
      searchReset() {
        this.search.activityName = ''
        this.search.projectGroupName = ''
        this.search.organizedBy = ''
        this.search.lecturer = ''
        this.search.searchTime = []
        this.searchChange()
      },
      handleCurrentChange(val) {
        this.page.currentPage = val
        this.search.current = val
        this.getStatisticsSummaryData()
      },
      handleRefreshChange() {
        this.getStatisticsSummaryData()
      },
      handleSizeChange(val) {
        this.page.pageSize = val
        this.page.currentPage = 1
        this.search.size = val
        this.search.current = 1
        this.getStatisticsSummaryData()
      },
      handleSortChange(val) {
        if (val.prop == 'startTime') {
          this.search.sortField = 'start_time'
        } else if (val.prop == 'endTime') {
          this.search.sortField = 'end_time'
        } else if (val.prop == 'participationRate') {
          this.search.sortField = 'participation_rate'
        } else if (val.prop == 'questionnaireParticipantCount') {
          this.search.sortField = 'questionnaire_participant_count'
        } else if (val.prop == 'questionnaireTotalScore') {
          this.search.sortField = 'questionnaire_total_score'
        } else if (val.prop == 'questionnaireAverageScore') {
          this.search.sortField = 'questionnaire_average_score'
        } else if (val.prop == 'questionnaireParticipationRate') {
          this.search.sortField = 'questionnaire_participation_rate'
        } else {
          this.search.sortField = 'id'
        }
        if (val.order == 'ascending') {
          this.search.sortPolicy = 'asc'
        } else if (val.order == 'descending') {
          this.search.sortPolicy = 'desc'
        } else {
          this.search.sortField = 'id'
          this.search.sortPolicy = 'desc'
        }
        this.getStatisticsSummaryData()
      },
      handleExport() {
        let params = {}
        if (this.search.activityName != '' && this.search.activityName.trim() != '')
          params.activityName = this.search.activityName
        if (this.search.projectGroupName != '' && this.search.projectGroupName.trim() != '')
          params.projectGroupName = this.search.projectGroupName
        if (this.search.organizedBy != '' && this.search.organizedBy.trim() != '')
          params.organizedBy = this.search.organizedBy
        if (this.search.lecturer != '' && this.search.lecturer.trim() != '')
          params.lecturer = this.search.lecturer

        if (this.startTime && this.endTime) {
          params.startTime = this.startTime
          params.endTime = this.endTime
        } else {
          params.startTime = null
          params.endTime = null
        }

        if (this.search.sortField != '' && this.search.sortField.trim() != '')
          params.sortField = this.search.sortField
        else {
          params.sortField = 'id'
        }
        if (this.search.sortPolicy != '' && this.search.sortPolicy.trim() != '')
          params.sortPolicy = this.search.sortPolicy
        else {
          params.sortPolicy = 'desc'
        }

        exportTrainingCourseStatisticsSummary(params).then(response => {
          if (response.status === 200 && response.data && response.data.data) {
            this.exportLoading = true
            this.exportName = '导出中...'
            exporting(response.data.data, this.exportCallback)
          } else {
            this.$message({
              message: '数据导出失败',
              type: 'warning',
              showClose: true,
            });
          }
        });
      },
      exportCallback(result) {
        this.exportLoading = false
        this.exportName = '导出'
        if (result) {
          this.$message({
            showClose: true,
            message: '导出完成',
            type: 'success'
          })
        }
      },
    }
  };
</script>

<style lang="scss" scoped>
.statistics-list {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-empty {
      display: block;
    }
    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }
    &-value {
      width: calc(100% - 12px) !important;
    }
    &-location-value {
      width: calc(100% - 12px) !important;
      input {
        border: none !important;
      }
    }
    &-date {
      width: 96%!important;
    }
    &-search {
      float: right;
      margin-right: 10px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
  &-container {
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
    }
  }
}
</style>
